import { invariant, InvariantError } from "ts-invariant";
import DEV from "./DEV.js";
export { DEV };
export var __DEV__ = DEV;
import { removeTemporaryGlobals } from "./fix-graphql.js";
removeTemporaryGlobals();
export { maybe } from "./maybe.js";
export { default as global } from "./global.js";
export { invariant, InvariantError };
//# sourceMappingURL=index.js.map